/**
 * Координати пристрою для геофенса відмітки (WORKSHOP_LAT/LON на беку).
 *
 * Ніколи не кидає і не блокує: якщо браузер не дав дозволу або GPS мовчить —
 * повертає null, а рішення приймає сервер (при вимкненому геофенсі порожні
 * координати нормальні, при увімкненому — 403 з поясненням).
 */
export function getGeoCoords(): Promise<{ lat: number; lon: number } | null> {
  return new Promise((res) => {
    if (!navigator.geolocation) return res(null);
    navigator.geolocation.getCurrentPosition(
      (p) => res({ lat: p.coords.latitude, lon: p.coords.longitude }),
      () => res(null),
      { enableHighAccuracy: false, timeout: 8000, maximumAge: 60_000 },
    );
  });
}
